const INTERNATIONAL_MINIMUM_AGE = 15

export function getBirthDateMinimumAge(config = {}) {
  const iso3 = String(config.iso3 || '').toUpperCase()

  if (iso3 && iso3 !== 'BRA') {
    return INTERNATIONAL_MINIMUM_AGE
  }

  const steps = config.registrationSteps || []
  if (steps.includes('SearchUser')) {
    return 0
  }

  if (config.minimumAgeToAccount != null && config.minimumAgeToAccount !== '') {
    return Number(config.minimumAgeToAccount) || 0
  }

  return 0
}
